import _ from 'lodash';
import { getField, updateField } from 'vuex-map-fields';
const state = {
    asistente_step: '',
    id_reporte: '',
    nombre: '',
    apellido: '',
    email: '',
    celular: '',
    vr_oferta: 0
};
/**Esto son funciones que modifican el estado original */
const mutations = {
    updateField
};
/**Esta funcion trae valores de los estados */
const getters = {
    getField
};
export default {
    namespaced: true,
    state,
    mutations,
    getters
}
